import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../../environments/environment';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../../core/core.module';
import { AssignmentService } from '../../../_services/assignment.service';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Utility } from '../../../../core/utils/utility';
import { StartupProfileService } from '../../../../panel/_services/startup-profile.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbNavModule,
    InputTextModule,
    ConfirmDialogModule,
    CoreModule    
  ],
  templateUrl: './assignment-detail.component.html',
  styleUrl: './assignment-detail.component.scss',
  providers: [ConfirmationService]
})
export class AssignmentDetailComponent {
  fileServerUrl = environment.fileServerUrl;
  defaultAvatar = environment.defaultAvatar;
  profileImageUrl = environment.defaultAvatar;
  session: any;
  teacher: any;
  teacherUniversity: any;
  teacherLearners: any;
  chapter: any;
  id!: any;
  index: any;
  prevLesson: any;
  nextLesson: any;
  completedCount: any;
  assignments: any;
  myForm: FormGroup;
  loading: boolean = false;
  homework: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assignmentService: AssignmentService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private startupService: StartupProfileService,
    private translate: TranslateService
  ) {

    let id = route.snapshot.paramMap.get('id');

    this.assignmentService.getHomeworkByAssignmentId(id as string, route.snapshot.queryParamMap.get('startupid')).subscribe((res: any) => {
      this.homework = res;
    });

    this.myForm = this.fb.group({
      scopeId: route.snapshot.queryParamMap.get('startupid') || '',
      assignmentId: id,
      attachments: fb.array([])
    });

    if (!route.snapshot.queryParamMap.get('startupid')) {
      startupService.getForedit(null).subscribe(x => {
        this.myForm.get('scopeId')?.setValue(x.id);
      })
    }

  }

  onSelectAttachment(event: any) {
    const files: FileList = event.target.files;
    if (files) {
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        (<FormArray>this.myForm.get('attachments'))?.push(new FormControl(file));
      }
    }
  }

  removeAttachment(index: number) {
    (<FormArray>this.myForm.get('attachments')).removeAt(index);
  }

  deleteAttachment(item: any, index: number, e: any) {
    this.confirmationService.confirm({
      target: e.target as EventTarget,
      message: this.translate.instant('LMS.ASSIGNMENTS.DETAIL.DELETE_CONFIRM_MESSAGE'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.assignmentService.deleteHomeWorkAttachment(item.id).subscribe((_: any) => {
          this.homework.attachments.splice(index, 1);
        })
      },
      reject: () => {
      }
    });
  }

  downloadAssignmentTemplate(id: number) {
    this.assignmentService.downloadAssignment(id).subscribe(res => {
      const downloadedFile = new Blob([res], { type: res.type });
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.href = URL.createObjectURL(downloadedFile);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    })
  }

  download(item: any) {
    this.assignmentService.getHomeworkAttachment(item.id).subscribe(res => {
      const downloadedFile = new Blob([res], { type: res.type });
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      if (!Utility.isPhoto(item.originalFileName))
        a.download = item.originalFileName;
      a.href = URL.createObjectURL(downloadedFile);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    })
  }

  onSubmit() {
    if (!this.myForm.value.attachments?.length) {
      this.messageService.add({ detail: this.translate.instant('PANEL.LMS.SESSIONS.SELECT_FILES'), severity: 'warn' });
      return;
    }

    this.loading = true;
    this.assignmentService.submitHomework(this.myForm.value).subscribe((res: any) => {
      this.loading = false;
      this.messageService.add({ detail: this.translate.instant('PANEL.LMS.SESSIONS.SUBMIT_SUCCESS'), severity: 'success' });
      this.router.navigate(['../..'], { relativeTo: this.route, fragment: 'assignments', queryParamsHandling: 'preserve' });
    }, err => {
      this.loading = false;
      this.messageService.add({ detail: this.translate.instant('PANEL.LMS.SESSIONS.SUBMIT_ERROR'), severity: 'error' });
    })
  }
}
